import React from 'react';
import TruckAnimation from './TruckAnimation';

const RETRY_STYLE = { height: 48, padding: '0 28px', borderRadius: 24, border: 'none', background: 'var(--color-accent)', color: '#1a1a2e', fontSize: 15, fontWeight: 700, cursor: 'pointer' };

// Liten inline-lastebil (knapper) eller sentrert laster med synlig tekst (showLabel).
export function TruckLoader({ label = 'Laster', size = 72, theme = 'light', showLabel = false, decorative = false, style }) {
  if (!showLabel) {
    return <TruckAnimation variant="load" theme={theme} size={size} label={label} decorative={decorative} style={style} />;
  }
  return (
    <div className="tippi-truck-loader" style={style}>
      <TruckAnimation variant="load" theme={theme} size={size} label={label} decorative />
      <span role="status" style={{ fontSize: 14, color: 'var(--color-text-light)' }}>{label}</span>
    </div>
  );
}

function StateBlock({ variant, title, text, theme, size, children }) {
  return (
    <div className="tippi-truck-state">
      <TruckAnimation variant={variant} theme={theme} size={size} label={title} />
      {title && <h2 className="tippi-truck-state__title">{title}</h2>}
      {text && <p className="tippi-truck-state__text">{text}</p>}
      {children}
    </div>
  );
}

export function TruckEmpty({ title = 'Ingen treff', text, theme = 'light', size = 150, children }) {
  return <StateBlock variant="empty" title={title} text={text} theme={theme} size={size}>{children}</StateBlock>;
}

export function TruckSuccess({ title = 'Ferdig', text, theme = 'light', size = 150, children }) {
  return <StateBlock variant="success" title={title} text={text} theme={theme} size={size}>{children}</StateBlock>;
}

export function TruckError({ title = 'Noe gikk galt', text, onRetry, theme = 'light', size = 150 }) {
  return (
    <StateBlock variant="fail" title={title} text={text} theme={theme} size={size}>
      {onRetry && (
        <button type="button" className="tippi-btn tippi-truck-state__action" style={RETRY_STYLE} onClick={onRetry}>Prøv igjen</button>
      )}
    </StateBlock>
  );
}

// Appstart/innlogging: tegnes opp én gang og blir stående (loop for å gjenta).
export function TruckIntro({ size = 160, theme = 'light', loop = false }) {
  return <TruckAnimation variant="intro" theme={theme} size={size} loop={loop} />;
}

// Aktivt oppdrag under transport.
export function TruckDriving({ size = 120, theme = 'light', label = 'På vei' }) {
  return <TruckAnimation variant="drive" theme={theme} size={size} label={label} />;
}
